__webpack_require__.p = "https://inventario.jbesolucoes.com.br/";